import { DataBean } from "../DataBean";

export class AmortizationType extends DataBean {

    public async getAmortizationTypeCatalog(idAmortizationType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAmortizationTypeCatalog_Number", [idAmortizationType]);
    }

    public async deleteAmortizationType(idAmortizationType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteAmortizationType_Number", [idAmortizationType]);
    }

    public async updateAmortizationType(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.loans.AmortizationType_updateAmortizationType_com.quickdataerp.bean.loans.AmortizationType", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.loans.AmortizationType"
            }
        ]);
    }

}
